import gql from 'graphql-tag';

const GET_FEEDBACK_TEMPLATE_QUERY = gql`
  query getTemplate($templateId: ID!) {
    getTemplate(templateId: $templateId) {
      name
      fields
      rootComponents
      components {
        id
        type
        name
        ... on OptionTemplateComponent {
          options {
            title
            value
          }
        }
        ... on FreeTextTemplateComponent {
          size
        }
        ... on RatingTemplateComponent {
          minValue
          maxValue
        }
        ... on MultipleSelectTemplateComponent {
          options {
            title
            value
          }
        }
        child {
          condition
          componentId
        }
      }
    }
  }
`;

const GET_FEEDBACK_DATA_QUERY = gql`
  query getFeedback($contentId: String!, $templateId: ID!, $userId: String!) {
    getFeedback(contentId: $contentId, templateId: $templateId, userId: $userId) {
      data
    }
  }
`;

const COMPONENT_TYPES = {
  CHOICE: 'CHOICE',
  FREETEXT: 'FREETEXT',
};

export { GET_FEEDBACK_TEMPLATE_QUERY, GET_FEEDBACK_DATA_QUERY, COMPONENT_TYPES };
